'use client'

'use client'

import { getCookie } from 'cookies-next'
import React, { useEffect, useState } from 'react'
import { FieldValues, useForm } from 'react-hook-form'
import { selectTheme, selectDirection, selectOrganization, selectAmountOfHeads } from '@/assets/data/review-data'
import { useGetRegionsQuery, useSendFormDataMutation, useSendManagerFeedbackMutation } from '@/redux/services/reviewApi'
import { useTranslation } from 'react-i18next'
import { memo } from 'react'

import s from './ManagerFeedbackForm.module.scss'
import ForPartnersNameInput from '@/components/ForPartners/ForPartnersNameInput'
import ForPartnersMail from '@/components/ForPartners/ForPartnersMail'
import ForPartnersPhone from '@/components/ForPartners/ForPartnersPhone'
import ForPartnersMessage from '@/components/ForPartners/ForPartnersMessage'
import ForPartnersAgree from '@/components/ForPartners/ForPartnersAgree'
import PersonAvatar from '@/components/PersonAvatar'
import Link from 'next/link'
import { useModal } from '@/components/Modal/Modal'

interface IManagerFeedbackFormProps {
    manager?: {
        image: string
        post: string
        name: string
        id: number
        email?: string
    }
    product?: string
}

export const ManagerFeedbackForm = memo(({ manager, product }: IManagerFeedbackFormProps) => {
    const { t } = useTranslation()
    const [labelsList] = useState({
        topic: t('footerFormthemeUp'),
        direction: t('footerFormProducts'),
        organizationType: t('footerFormImagine'),
        amountOfHeads: t('footerFormCountOfHeads')
    })
    const [regions, setRegions] = useState([])
    const [phoneValue, setPhoneValue] = useState('')
    const [messageValue, setMessageValue] = useState('')
    const [submitForm] = useSendManagerFeedbackMutation()
    const [isSuccess, setIsSuccess] = useState(false)
    const [modal, setModal] = useModal()

    const {
        register,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors },
        reset,
        watch
    } = useForm({
        mode: 'onSubmit',
        reValidateMode: 'onSubmit'
    })

    const { data: regionsData } = useGetRegionsQuery()

    useEffect(() => {
        setRegions(regionsData)
    }, [regionsData])

    const watchAllFields = watch()
    const fieldsFilled = watchAllFields.name && watchAllFields.email && watchAllFields.message && watchAllFields.robot

    const onSubmit = (data: any) => {
        console.log(data)
        submitForm({ ...data, manager: manager.id, product: product }).then(res => console.log(res))
        // const processedData = Object.fromEntries(Object.entries(data)?.map(([key, value]) => [key, value ?? '']))

        // processedData.token = csrf
        // processedData.robot = !processedData.robot
        // processedData.heads_amount = processedData['heads-amount'] //FIX
        // processedData.organization_type = processedData['organization-type'] //FIX
        // processedData.message = messageValue
        // delete processedData['heads-amount'] //FIX
        // delete processedData['organization-type'] //FIX

        // submitForm(processedData)

        setIsSuccess(true)
        // setPhoneValue('')
        // setMessageValue('')
        // setValue('robot', false)
        // setOption('region', '')
        // setOption('theme', selectTheme[0].name)
        // setOption('direction', selectDirection[0].name)
        // setOption('organizationType', selectOrganization[0].name)
        // setOption('amountOfHeads', selectAmountOfHeads[0].name)
        reset()
    }

    return (
        <div className={s.authorization}>
            <div className={s.close} onClick={()=>setModal(false)} style={{cursor: "pointer"}}>
                <svg
                    width='15'
                    height='14'
                    viewBox='0 0 15 14'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <path
                        fill-rule='evenodd'
                        clip-rule='evenodd'
                        d='M0.262307 0.267499C0.614067 -0.0871283 1.18671 -0.0894536 1.54134 0.262307L7.23009 5.90506L12.9188 0.262307C13.2735 -0.0894536 13.8461 -0.0871283 14.1979 0.267499C14.5496 0.622127 14.5473 1.19477 14.1927 1.54653L8.51435 7.17894L13.8319 12.4535C14.1865 12.8052 14.1888 13.3779 13.8371 13.7325C13.4853 14.0871 12.9127 14.0895 12.558 13.7377L7.23009 8.45282L1.90214 13.7377C1.54751 14.0895 0.974869 14.0871 0.623108 13.7325C0.271348 13.3779 0.273672 12.8052 0.6283 12.4535L5.94582 7.17894L0.267499 1.54653C-0.0871288 1.19477 -0.0894531 0.622127 0.262307 0.267499Z'
                        fill='#A9B4D1'
                    />
                </svg>
            </div>
            <div className='for-partners'>
                {!isSuccess ? (
                    <div className={s.header_full}>
                        {<h2 className={`main__section-title ${s.title}`}>Свяжитесь с нами</h2>}
                        <div className={`for-partners__top ${s.header}`}>
                            <div className='for-partners__text'>
                                Наш специалист с радостью
                                <br /> ответит на все ваши вопросы.
                            </div>
                            <div className={`footer__media-social ${s.managerWrapper}`}>
                                {manager ? (
                                    <PersonAvatar
                                        image={manager.image}
                                        info={{ post: manager.post, email: manager.email, name: manager.name.replace('<br/>', ' ') }}
                                    />
                                ) : null}
                            </div>
                        </div>
                    </div>
                ) : null}
                {isSuccess ? (
                    <div className='for-partners__success-block'>
                        <p className='for-partners__success-text'>
                            Спасибо! <br />
                            Ваше сообщение отправлено, мы <br className='for-partners__success-text_translate' />{' '}
                            постараемся ответить как можно скорее.
                        </p>
                        <button
                            onClick={() => setIsSuccess(false)}
                            className={`for-partners__form-button for-partners__form-button_active`}
                        >
                            Новое сообщение
                        </button>
                    </div>
                ) : (
                    <form
                        action='/submit'
                        method='post'
                        className='for-partners__form' style={{maxWidth: "100dvw"}}
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <div className='for-partners__form-fields'>
                            <div className='for-partners__form-person'>
                                <ForPartnersNameInput
                                    errors={errors}
                                    register={register}
                                />
                                <ForPartnersMail
                                    errors={errors}
                                    register={register}
                                />
                                <ForPartnersPhone
                                    value={phoneValue}
                                    setValue={(val: string) => setPhoneValue(val)}
                                    errors={errors}
                                    register={register}
                                />
                            </div>
                            <div className={`for-partners__form-message ${s.message}`}>
                                <ForPartnersMessage
                                    messageValue={messageValue}
                                    setValue={val => setMessageValue(val)}
                                    register={register}
                                />
                                <ForPartnersAgree
                                    setValue={(state: boolean) => setValue('robot', state)}
                                    register={register}
                                    text={
                                        <>
                                            согласие с{' '}
                                            <Link
                                                href={'/confidential'}
                                                className={`for-partners__politics ${s.colored}`}
                                            >
                                                политикой обработки данных
                                            </Link>
                                        </>
                                    }
                                />
                            </div>
                        </div>
                        <button
                            disabled={!fieldsFilled}
                            className={`for-partners__form-button ${
                                fieldsFilled && 'for-partners__form-button_active'
                            }`}
                        >
                            {t('send')}
                        </button>
                    </form>
                )}
            </div>
        </div>
    )
})
